import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

// styles for this kit
import "assets/css/bootstrap.min.css";
import "assets/scss/now-ui-kit.scss?v=1.5.0";
import "assets/demo/demo.css?v=1.5.0";
import "assets/demo/nucleo-icons-page-styles.css?v=1.5.0";
// pages for this kit
import NucleoIcons from "../src/views/NucleoIcons";
import LandingPage from "../src/views/examples/LandingPage";
import ProfilePage from "../src/views/examples/ProfilePage";
import CulturePage from "../src/views/examples/CulturePage";
import StructurePage from "../src/views/examples/StructurePage";
import MilestonePage from "../src/views/examples/MilestonePage";
import Utschool from "../src/views/examples/UtschoolPage";
import Dcare from "../src/views/examples/DcarePage";
import Klinik from "../src/views/examples/KlinikPage";
import Governance from "../src/views/examples/PelaporanPage";
import Career from "../src/views/examples/CareerPage";
import Rekrutmen from "../src/views/examples/RecruitmentPage";
import Faq from "../src/views/examples/FaqsPage";
import Galerry from "../src/views/examples/GalerryPage";
import BlogPage from "../src/views/examples/BlogPage";
import DetailMedia from "../src/views/examples/BlogDetailPage";
import ContactPage from "../src/views/examples/ContactPage";
import Entitas from "../src/views/examples/EntityPage";
import Visimisi from "../src/views/examples/VisimisiPage";
import Program from "../src/views/examples/ProgramPage";
import CookiesPopup from "../src/views/CookiesPopup";
import Kebijakan from "../src/views/examples/KebijakanPage";
import KodeEtikPage from "views/examples/KodeEtikPage";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <BrowserRouter>
        <CookiesPopup />
        <Routes>
            <Route path="/nucleo-icons" element={<NucleoIcons />} />
            <Route path="/" element={<LandingPage />} />
            <Route path="/about" element={<ProfilePage />} />
            <Route path="/budaya" element={<CulturePage />} />
            <Route path="/organisasi" element={<StructurePage />} />
            <Route path="/jejak" element={<MilestonePage />} />
            <Route path="/utschool" element={<Utschool />} />
            <Route path="/dcare" element={<Dcare />} />
            <Route path="/klinik-pratama" element={<Klinik />} />
            <Route path="/berkarir-di-ykbut" element={<Career />} />
            <Route path="/pelaporan" element={<Governance />} />
            <Route path="/kode-etik" element={<KodeEtikPage />} />
            <Route path="/info-rekrutmen" element={<Rekrutmen />} />
            <Route path="/faqs" element={<Faq />} />
            <Route path="/galeri" element={<Galerry />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/detail-blog/:photoTitle" element={<DetailMedia />} />
            <Route path="/hubungi" element={<ContactPage />} />
            <Route path="/entitas" element={<Entitas />} />
            <Route path="/visi-misi" element={<Visimisi />} />
            <Route path="/kebijakan-privasi" element={<Kebijakan />} />
            <Route path="/program/:id_program" element={<Program />} />

            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    </BrowserRouter>
);
